module.exports = __webpack_public_path__ + "img/theme-6-violet.1cecddcb.svg";